import React, { useCallback, useEffect, useRef, useState } from "react";
import { Card, Dropin, PayPal, CashAppPay, GooglePay } from "@adyen/adyen-web";

import {
  AdditionalDetailsActions,
  AdditionalDetailsData,
  AdyenCheckout,
  AdyenCheckoutError,
  CoreConfiguration,
  DropinConfiguration,
  PaymentCompletedData,
  PaymentFailedData,
  SubmitActions,
  SubmitData,
  UIElement,
} from "@adyen/adyen-web";
import "@adyen/adyen-web/styles/adyen.css";

import paymentMethodsCall, {
  paymentDetailsCall,
  paymentsCall,
  SessionsSetupCall,
} from "./hooks";

import "./index.css";
import "./adyen.css";
import { useNavigate } from "react-router-dom";

export function Adyen() {
  let dropinRef = useRef<HTMLDivElement>(null);
  const [transactionId, setTransactionId] = useState("");
  const [isPaymentComplete, setIsPaymentComplete] = useState(false);
  const locale = localStorage.getItem("lang") || "fr-FR";
  const store = localStorage.getItem("shopReference");
  const totalPrice = Number(localStorage.getItem("amount"));
  const navigate = useNavigate();

  const amount = {
    currency: "EUR",
    value: Math.round(totalPrice * 100),
  };
  const clientKey = process.env.REACT_APP_PUBLIC_ADYEN_CLIENT_KEY;
  const environment: any = process.env.REACT_APP_PUBLIC_ADYEN_ENV;
  const countryCode = "FR";

  const isAdyenWebInitialized = useRef<boolean>(false);
  const loadAdyen = useCallback(async () => {
    const session = await SessionsSetupCall({
      locale,
      countryCode,
      amount,
      store,
    });

    const paymentMethodsResponse = await paymentMethodsCall({
      locale,
      countryCode: countryCode,
      amount,
      store,
    });

    const options: CoreConfiguration = {
      clientKey,
      session: {
        id: session.id,
        sessionData: session.sessionData,
      },
      countryCode,
      amount,
      locale,
      environment,
      analytics: {
        enabled: false,
      },
      paymentMethodsResponse,
      onSubmit: async (
        state: SubmitData,
        component: UIElement,
        actions: SubmitActions
      ) => {
        try {
          const result = await paymentsCall(
            state.data,
            countryCode,
            locale,
            amount,
            store
          );
          if (!result.resultCode) {
            actions.reject();
            return;
          }

          if (result.resultCode === "Authorised" && result.pspReference) {
            setTransactionId(result.pspReference);
          } else {
            console.error("Payment failed or no pspReference found");
          }

          actions.resolve(result);
        } catch (error) {
          console.error("onSubmit", error);
          actions.reject();
        }
      },

      onAdditionalDetails: async (
        state: AdditionalDetailsData,
        component: UIElement,
        actions: AdditionalDetailsActions
      ) => {
        try {
          const result = await paymentDetailsCall(state.data);

          if (result.resultCode) {
            actions.resolve(result);
          } else {
            actions.reject();
          }
        } catch (error) {
          console.error("onSubmit", error);
          actions.reject();
        }
      },

      onError(error: AdyenCheckoutError) {
        console.log("error: ", error);
      },

      onPaymentCompleted(data: PaymentCompletedData, element: UIElement) {
        setIsPaymentComplete(true);
      },

      onPaymentFailed(data: PaymentFailedData, element: UIElement) {},
    };

    const checkoutInstance: any = await AdyenCheckout(options);
    const dropinConfiguration: DropinConfiguration = {
      paymentMethodsConfiguration: {
        card: {
          _disableClickToPay: true,
        },
      },
      paymentMethodComponents: [Card, PayPal, CashAppPay, GooglePay],
    };

    if (dropinRef.current) {
      new Dropin(checkoutInstance, dropinConfiguration).mount(
        dropinRef.current
      );
      // const dataOrder = await insertOrderDetails();
    }
  }, []);

  useEffect(() => {
    if (!isAdyenWebInitialized.current) {
      isAdyenWebInitialized.current = true;
      void loadAdyen();
    }
  }, [loadAdyen]);

  React.useEffect(() => {
    if (transactionId) {
      if (isPaymentComplete) {
        navigate("/successPayment?" + transactionId);
      } else {
        navigate("/failedPayment");
      }
    }
  }, [transactionId]);

  return <div ref={dropinRef} id="dropin" />;
}
